/**
 * Texte des Belegungskopfs: der Zeitraum als Knopfbeschriftung („16. – 29. Okt.“) und als Satz
 * unter dem Titel („Freitag, 16. bis Donnerstag, 29. Oktober 2026 · heute Montag, 19.“). Monat und
 * Jahr stehen nur so oft da, wie sie sich ändern.
 */
import { parseDate } from './calendarDates';

const fmt = (options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('de-DE', { ...options, timeZone: 'UTC' });

const shortDayMonth = fmt({ day: 'numeric', month: 'short' });
const shortFull = fmt({ day: 'numeric', month: 'short', year: 'numeric' });
const weekday = fmt({ weekday: 'long' });
const monthLong = fmt({ month: 'long' });

export function rangeLabel(from: string, to: string): string {
  const start = parseDate(from);
  const end = parseDate(to);
  const thisYear = start.getUTCFullYear() === end.getUTCFullYear();
  if (!thisYear) return `${shortFull.format(start)} – ${shortFull.format(end)}`;
  if (start.getUTCMonth() !== end.getUTCMonth()) {
    return `${shortDayMonth.format(start)} – ${shortDayMonth.format(end)}`;
  }
  return `${start.getUTCDate()}. – ${shortDayMonth.format(end)}`;
}

const WEEKDAY_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
const compactDay = (date: Date) =>
  `${WEEKDAY_SHORT[date.getUTCDay()]} ${date.getUTCDate()}.${date.getUTCMonth() + 1}.`;

/** „Mo 19.10. – So 25.10.“ – der Zeitraum unter dem Titel am Handy, wo der Satz zu lang ist. */
export function rangeCompact(from: string, to: string): string {
  return `${compactDay(parseDate(from))} – ${compactDay(parseDate(to))}`;
}

function longDay(date: Date, withMonth: boolean, withYear: boolean): string {
  const parts = [`${weekday.format(date)}, ${date.getUTCDate()}.`];
  if (withMonth) parts.push(monthLong.format(date));
  if (withYear) parts.push(String(date.getUTCFullYear()));
  return parts.join(' ');
}

export function rangeSentence(from: string, to: string, today: string): string {
  const start = parseDate(from);
  const end = parseDate(to);
  const now = parseDate(today);
  const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
  const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
  const range =
    from === to
      ? longDay(end, true, true)
      : `${longDay(start, !sameMonth, !sameYear)} bis ${longDay(end, true, true)}`;
  const todayYear = now.getUTCFullYear() !== end.getUTCFullYear();
  const todayMonth = todayYear || now.getUTCMonth() !== end.getUTCMonth();
  return `${range} · heute ${longDay(now, todayMonth, todayYear)}`;
}
